import { useQuery } from 'react-query';
import { getSmartResponses } from '@vs-online-only-app/state';

export const useGetSmartResponses = (enabled = true) =>
  useQuery(['getAssociateInsights'], () => getSmartResponses(), {
    staleTime: Infinity,
    enabled,
  });
